var _excluded = ["noteType", "InvoiceNumber"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareKeys from '../../../../../locales/keys';
import { createConvergentBillerAdjustment, retrieveLedgerSummary } from '../../../../../reducers/actions/customer.billing.actions';
import { fetchCustomerInventory } from '../../../../../reducers/actions/customer.inventory.actions';
import { CurrentCustomerIdSelector, CurrentCustomerCurrencyCodeSelector } from '../../../../../reducers/selectors/customer.selectors';
import { DateTimeHelper } from 'invision-core';
import { OPEN_INVOICES, CREDIT_NOTE_TYPE, CONVERT_TO_CREDIT } from '../../../../billingPayments/billing.payments.constants';
import { MISC_ADJUSTMENT } from '../../../../adjustment/adjustment.modal.constants';
import { BillingPaymentsOpenInvoicesSelector, InvoiceListForOpenInvoiceWidgetSelector, IsFetchingOpenInvoicesSelector, OpenInvoicesRecordCountSelector, TotalAccountBalanceSelector, TotalCashReceivableSelector, TotalWithheldTaxSelector } from '../../../../../reducers/selectors/customer.billing.selectors';
import { IsDbss, CurrentBusinessUnitTimeZoneSelector } from 'invision-core/src/components/session/businessunit.selectors';
import { stateGo } from 'redux-ui-router';
import i18n from 'invision-core/src/components/i18n/i18n';
import { MAKE_PAYMENT_ROUTE } from '../../../makePayment/make.payment.constants';
import { CASE_CATEGORIES } from '../../../../customer/cases/list/case.constants';
import { CASES_DETAILS_STATE_REDIRECT } from '../../../../customer/cases/cases.config';
import { CurrentAccountSummarySelector } from '../../../../../reducers/selectors/customer.convergent.biller.selectors';
import { getFilterService } from 'invision-core/src/components/injectables/injector.helper';
var OpenInvoicesWidgetController = /*#__PURE__*/function () {
  function OpenInvoicesWidgetController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, OpenInvoicesWidgetController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      CASE_CATEGORIES: CASE_CATEGORIES,
      currentCase: {},
      disputeInvoice: this.disputeInvoice.bind(this),
      uiNotificationService: uiNotificationService,
      goToInvoiceDetails: this.goToInvoiceDetails.bind(this),
      handleConvertToCreditModalClose: this.handleConvertToCreditModalClose.bind(this),
      makeAdjustment: this.makeAdjustment.bind(this),
      onConvertToCreditFormSubmit: this.onConvertToCreditFormSubmit.bind(this),
      openConvertToCredit: this.openConvertToCredit.bind(this),
      openAdjustmentModal: this.openAdjustmentModal.bind(this),
      goToMakePayment: this.goToMakePayment.bind(this),
      hasLatePayment: this.hasLatePayment.bind(this),
      infoToolTipTemplate: require('../../../../shared/tooltipTemplates/open.invoices.tooltip.template.html'),
      CustomerCareKeys: CustomerCareKeys,
      isConvertToCreditModalOpen: false,
      isExpanded: false
    });
  }
  return _createClass(OpenInvoicesWidgetController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currencyCode: CurrentCustomerCurrencyCodeSelector(store),
          currentAccountSummary: CurrentAccountSummarySelector(store),
          currentBUTimeZone: CurrentBusinessUnitTimeZoneSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          invoiceData: InvoiceListForOpenInvoiceWidgetSelector(store),
          invoiceList: BillingPaymentsOpenInvoicesSelector(store),
          isDbss: IsDbss(store),
          isFetchingOpenInvoices: IsFetchingOpenInvoicesSelector(store),
          recordCountOfLedger: OpenInvoicesRecordCountSelector(store),
          totalAccountBalance: TotalAccountBalanceSelector(store),
          totalCashReceivable: TotalCashReceivableSelector(store),
          totalWithheldTax: TotalWithheldTaxSelector(store)
        };
      };
      var controllerActions = {
        createConvergentBillerAdjustment: createConvergentBillerAdjustment,
        fetchCustomerInventory: fetchCustomerInventory,
        retrieveLedgerSummary: retrieveLedgerSummary,
        stateGo: stateGo
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.retrieveLedgerSummary();
      this.adjustmentModalConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.adjustmentModalApi = api;
        }
      };
      this.caseModalProps = {
        isOpen: false,
        onClose: function onClose() {
          _this.caseModalProps.isOpen = false;
        },
        onSubmit: function onSubmit(caseDetails) {
          _this.caseModalProps.isOpen = false;
          _this.uiNotificationService.success(i18n.translate(_this.CustomerCareKeys.CASE.CREATED_SUCCESSFULLY));
          _this.actions.stateGo(CASES_DETAILS_STATE_REDIRECT, {
            customerId: _this.state.currentCustomerId,
            caseId: caseDetails.Id.Value
          });
        },
        openCaseModal: function openCaseModal(invoiceNumber) {
          _this.caseModalProps.disputeDetails.selectedInvoiceNumber = invoiceNumber;
          _this.caseModalProps.isOpen = true;
        },
        disputeDetails: {
          selectedInvoiceNumber: ''
        },
        caseTemplateId: CASE_CATEGORIES.INVOICE_DISPUTE,
        routeParams: {
          customerId: this.state.currentCustomerId
        }
      };
    }
  }, {
    key: "handleExpansion",
    value: function handleExpansion() {
      this.isExpanded = !this.isExpanded;
    }
  }, {
    key: "goToInvoiceDetails",
    value: function goToInvoiceDetails(id) {
      this.actions.stateGo('index.customercare.customer.billingpayments.detail', {
        invoiceId: id
      });
    }
  }, {
    key: "retrieveLedgerSummary",
    value: function retrieveLedgerSummary() {
      var _this2 = this;
      var request = {
        customerId: this.state.currentCustomerId,
        request: {
          Filter: OPEN_INVOICES,
          IncludeAccountBalance: true,
          PageNumber: 1,
          PageSize: 12
        }
      };
      this.actions.retrieveLedgerSummary(request, true).then(function () {
        _this2.isExpanded = true;
        _this2.invoiceDataForWidget = _this2.state.invoiceData;
        _this2.invoiceDataForCollapsedWidget = _this2.state.invoiceData.slice(0, 4);
        _this2.viewAllText = i18n.translate(_this2.CustomerCareKeys.CUSTOMER_DASHBOARD.VIEW_ALL_OPEN_INVOICES, {
          count: _this2.state.recordCountOfLedger
        });
        _this2.showExpandCollapseIcon = _this2.state.invoiceData.length > 4;
        if (_this2.closeAdjustmentModal) {
          _this2.onAdjustmentClose();
          _this2.closeAdjustmentModal = false;
        }
        if (_this2.isConvertToCreditModalOpen) {
          _this2.handleConvertToCreditModalClose();
        }
      }).catch(function (error) {
        _this2.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "hasLatePayment",
    value: function hasLatePayment() {
      var _this$state, _this$state$currentAc;
      return (_this$state = this.state) !== null && _this$state !== void 0 && (_this$state$currentAc = _this$state.currentAccountSummary) !== null && _this$state$currentAc !== void 0 && _this$state$currentAc.PostpaidDetails && this.state.currentAccountSummary.PostpaidDetails.LatePaymentEligible ? this.state.currentAccountSummary.PostpaidDetails.LatePaymentAmountDue > 0 && this.state.currentAccountSummary.PostpaidDetails.DueDate !== null && this.state.currentAccountSummary.PostpaidDetails.LatePaymentFeeAmount > 0 : false;
    }
  }, {
    key: "latePaymentLabel",
    value: function latePaymentLabel() {
      var $filter = getFilterService();
      var latePayment = {
        dueAmount: $filter('invCurrency')(this.state.currentAccountSummary.PostpaidDetails.LatePaymentAmountDue, this.state.currentAccountSummary.PostpaidDetails.CurrencyCode),
        date: $filter('localShortDate')(this.state.currentAccountSummary.PostpaidDetails.DueDate),
        latePaymentFee: $filter('invCurrency')(this.state.currentAccountSummary.PostpaidDetails.LatePaymentFeeAmount, this.state.currentAccountSummary.PostpaidDetails.CurrencyCode)
      };
      return i18n.translate(this.CustomerCareKeys.CUSTOMER_DASHBOARD.LATE_PAYMENT_FEE.LATE_PAYMENT_FEE_LABEL, latePayment);
    }
  }, {
    key: "makeAdjustment",
    value: function makeAdjustment(actionItem) {
      this.openAdjustmentModal(actionItem);
    }
  }, {
    key: "onAdjustmentClose",
    value: function onAdjustmentClose() {
      this.adjustmentModalApi.close();
      this.invoiceDetails = {};
    }
  }, {
    key: "onFetchLedgerSummaryAdjustmentClose",
    value: function onFetchLedgerSummaryAdjustmentClose() {
      this.closeAdjustmentModal = true;
      this.retrieveLedgerSummary();
    }
  }, {
    key: "disputeInvoice",
    value: function disputeInvoice(actionItem) {
      this.caseModalProps.openCaseModal(actionItem.invoiceNumber);
    }
  }, {
    key: "openAdjustmentModal",
    value: function openAdjustmentModal(actionItem) {
      var _this3 = this;
      this.adjustmentType = MISC_ADJUSTMENT;
      this.$timeout(function () {
        _this3.adjustmentModalApi.open();
      });
      var invoiceItem = this.state.invoiceList.invoices.find(function (invoice) {
        return invoice.Invoice.InvoiceId === actionItem.id;
      });
      this.invoiceDetails = {
        accountNumber: invoiceItem.Invoice.AccountNumber,
        invoiceNumber: invoiceItem.Invoice.InvoiceNumber,
        invoiceId: invoiceItem.Invoice.InvoiceId,
        maxAmount: invoiceItem.Invoice.CurrentDue
      };
    }
  }, {
    key: "openConvertToCredit",
    value: function openConvertToCredit(actionItem) {
      var invoiceItem = this.state.invoiceList.invoices.find(function (invoice) {
        return invoice.Invoice.InvoiceId === actionItem.id;
      });
      this.convertToCreditInitialValues = {
        AccountNumber: invoiceItem.Invoice.AccountNumber,
        noteType: CREDIT_NOTE_TYPE,
        InvoiceId: invoiceItem.Invoice.InvoiceId,
        InvoiceNumber: invoiceItem.Invoice.InvoiceNumber,
        Amount: Math.abs(invoiceItem.Invoice.CurrentDue),
        GenerateStatement: true
      };
      this.isConvertToCreditModalOpen = true;
    }
  }, {
    key: "onConvertToCreditFormSubmit",
    value: function onConvertToCreditFormSubmit(formValues) {
      var _this4 = this;
      var noteType = formValues.noteType,
        InvoiceNumber = formValues.InvoiceNumber,
        convertToCreditFormValues = _objectWithoutProperties(formValues, _excluded);
      var currentDateInBillingTimezone = DateTimeHelper.offsetTimezone(new Date(), this.state.currentBUTimeZone);
      var request = {
        customerId: this.state.currentCustomerId,
        request: _objectSpread({
          AdjustmentTypeCode: CONVERT_TO_CREDIT,
          PostDate: currentDateInBillingTimezone
        }, convertToCreditFormValues)
      };
      this.actions.createConvergentBillerAdjustment(request).then(function () {
        _this4.isConvertToCreditModalOpen = false;
        _this4.retrieveLedgerSummary();
        _this4.uiNotificationService.transientSuccess(i18n.translate(_this4.CustomerCareKeys.CONVERT_TO_CREDIT_SUCCESS));
      }).catch(function (error) {
        _this4.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "handleConvertToCreditModalClose",
    value: function handleConvertToCreditModalClose() {
      this.isConvertToCreditModalOpen = false;
    }
  }, {
    key: "goToMakePayment",
    value: function goToMakePayment(invoiceDetails) {
      this.actions.stateGo(MAKE_PAYMENT_ROUTE, {
        invoiceNumber: invoiceDetails.invoiceNumber,
        paymentType: invoiceDetails.actionId
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./open.invoices.html'),
  controller: OpenInvoicesWidgetController,
  controllerAs: 'OpenInvoicesWidget'
};